import React from "react";
import "./styles.less";
import { Button } from "../../components/Button";
import { useTranslation } from "react-i18next";
import { CommonCode } from "../../blocks/common-code";
import { Title } from "../../components/NewTitle";

export const HomeCustomer = () => {
  const { t } = useTranslation();

  const list = [
    {
      alt: "deephow",
      imgurl: "//files.authing.co/authing-website/deephow.png",
    },
    {
      alt: "pingcap",
      imgurl: "//files.authing.co/authing-website/home-logo-ping-cap.png",
    },

    {
      alt: "cnpc",
      imgurl: "//files.authing.co/authing-website/home-logo-cnpc-new.png",
    },
    {
      alt: "元气森林单点登录SSO-统一身份认证客户案例",
      imgurl: "//files.authing.co/authing-website/home-logo-yuanqi-forest.png",
    },
    {
      alt: "coca-cola",
      imgurl: "//files.authing.co/authing-website/home-logo-coca-cola-v2.png",
    },
    {
      alt: "hep",
      imgurl: "//files.authing.co/authing-website/HEP.png",
    },
    {
      alt: "EY",
      imgurl: "//files.authing.co/authing-website/home-ey.png",
    },
    {
      alt: "bingli",
      imgurl: "//files.authing.co/authing-website/bentleymotors.png",
    },
    {
      alt: "treelab",
      imgurl: "//files.authing.co/authing-website/home-treelab-new.png",
    },

    {
      alt: "guangda",
      imgurl: "//files.authing.co/authing-website/home-guangda-new.png",
    },
    {
      alt: "southeast-university",
      imgurl: "//files.authing.co/authing-website/SEU.png",
    },
    {
      alt: "zhaoshang",
      imgurl: "//files.authing.co/authing-website/cmbchina.png",
    },
    {
      alt: "toyota",
      imgurl: "//files.authing.co/authing-website/TOYOTA.png",
    },

    {
      alt: "state-grid",
      imgurl: "//files.authing.co/authing-website/SG.png",
    },
    {
      alt: "jcd",
      imgurl: "//files.authing.co/authing-website/JCD.png",
    },
    {
      alt: "theragun",
      imgurl: "//files.authing.co/authing-website/THERAGUN.png",
    },
    {
      alt: "dazhong",
      imgurl: "//files.authing.co/authing-website/vw.png",
    },

    {
      alt: "bentley",
      imgurl: "//files.authing.co/authing-website/Bentley.png",
    },
    {
      alt: "bosch",
      imgurl: "//files.authing.co/authing-website/BOSCH.png",
    },
    {
      alt: "stackchat",
      imgurl: "//files.authing.co/authing-website/Stackchat.png",
    },
    {
      alt: "kerui",
      imgurl: "//files.authing.co/authing-website/home-logo-kerui.png",
    },
    {
      alt: "mingyu",
      imgurl: "//files.authing.co/authing-website/home-logo-mingyu.png",
    },

    // {
    //   alt: "wanke",
    //   imgurl: "//files.authing.co/authing-website/home-logo-wanke.png",
    // },
    {
      alt: "xiandai",
      imgurl: "//files.authing.co/authing-website/home-logo-xiandai.png",
    },
    {
      alt: "changxin",
      imgurl: "//files.authing.co/authing-website/home-logo-changxin.png",
    },
    {
      alt: "yishixiehui",
      imgurl: "//files.authing.co/authing-website/home-logo-yishixiehui.png",
    },
    // {
    //   alt: "cytiva",
    //   imgurl: "//files.authing.co/authing-website/home-logo-cytiva.png",
    // },
  ];

  return (
    <div className="home-customer">
      <div className="inner">
        <Title title={t("home.customer")} size="h2" />
        <div className="customer-logo-warp">
          <div className="customer-logos">
            <div className="scroll-mask"></div>
            <div className="scroll-container">
              {list.map((item, index) => {
                return (
                  <div key={index} className="customer-item">
                    <div className="customer-logo">
                      <img src={item.imgurl} alt={item.name} />
                    </div>
                  </div>
                );
              })}
              {/* 为了循环滚动 */}
              {list.map((item, index) => {
                return (
                  <div key={`${index}-copy`} className="customer-item">
                    <div className="customer-logo">
                      <img src={item.imgurl} alt={item.name} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
